import axiosInstance from "../../scenes/utils/axiosInstance";
import { API_ENDPOINTS } from "../../config/api";

export default class MrService {
  addMr = async (data) => {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.MR.UPLOAD,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };
  
  getPatientMr = async (patientId) => {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.MR.BY_PATIENT(patientId)
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };
  
  segmentMerged = async (mrID)=>{
    try{
      const response = await axiosInstance.post(API_ENDPOINTS.MR.ANALYZE(mrID, 'merged'));
      return response.data
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  }
  
  segmentFemur = async (mrID)=>{
    try{
      const response = await axiosInstance.post(API_ENDPOINTS.MR.ANALYZE(mrID, 'femur'));
      return response.data
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  }

  segmentFibula = async (mrID)=>{
    try{
      const response = await axiosInstance.post(API_ENDPOINTS.MR.ANALYZE(mrID, 'fibula'));
      return response.data
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  }

  segmentTibia = async (mrID)=>{
    try{
      const response = await axiosInstance.post(API_ENDPOINTS.MR.ANALYZE(mrID, 'tibia'));
      return response.data
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  }
}
